var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYtGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.997,
    height: 9.798,
    viewBox: "0 0 13.997 9.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    d: "M480.148,157.91a3.047,3.047,0,0,0-3.047-3.047h-7.9a3.047,3.047,0,0,0-3.047,3.047v3.7a3.047,3.047,0,0,0,3.047,3.047h7.9a3.047,3.047,0,0,0,3.047-3.047Zm-4.986,2.038-3.152,1.729c-.137.074-.26-.025-.26-.181v-3.548c0-.158.127-.257.264-.179l3.174,1.82A.207.207,0,0,1,475.162,159.949Z",
    transform: "translate(-466.151 -154.863)",
    fill: "rgba(51,51,51,0.4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtGrey);
export default __webpack_public_path__ + "static/media/yt-grey.683daeccc2d126f0ea75bb17d36911c3.svg";
export { ForwardRef as ReactComponent };